import { ToastContainer } from 'react-toastify';
import './App.css';
import AppRouter from './Routes/AppRouter';
import { AppContextProvider } from './context/appContext';

function App() {
  return (
    <AppContextProvider>
      <AppRouter />
      <ToastContainer />
    </AppContextProvider>
  );
}

export default App;
